<template>
  <app-page title="Remove Labels">
    <v-ons-list>
      <v-ons-list-header>Enter label</v-ons-list-header>
      <v-ons-list-item>
        <v-ons-input disable-auto-styling
          input-id="label"
          placeholder="Label"
          v-model="label"
          @keydown.enter="addLabel"
          @keydown.tab="addLabel"
        />
      </v-ons-list-item>
    </v-ons-list>
    <v-ons-list v-show="!!$store.removedLabels.length">
      <v-ons-list-header>Labels to be removed</v-ons-list-header>
      <v-ons-list-item v-for="item in $store.removedLabels" :key="item.label">
        <div class="center label-item">
          <span :class="{ error: item.error }">{{item.label}}</span>
        </div>
        <div class="right">
          <v-ons-icon
            @click="removeItem(item.label)" 
            icon="fa-times-circle" 
            class="remove-icon"/>
        </div>
      </v-ons-list-item>
    </v-ons-list>
  </app-page>
</template>

<script>
import util from "../util";
export default {
  data: () => ({ label: "" }),
  mounted: function() { util.focus("label"); },
  methods: {
    removeItem(l) {
      this.$store.removedLabels =
        this.$store.removedLabels.filter(item => item.label !== l);
      util.focus("label");
    },
    addLabel(evt) {
      evt.preventDefault();
      if (this.labelIsValid) {
        this.$store.removedLabels = 
          this.$store.removedLabels.filter(
            item => item.label !== this.label);
        this.$store.removedLabels.splice(0, 0, {
          label: this.label,
          error: false
        });
        util.sounds.success.play();
      } else {
        util.warn(this, "Invalid label: " + this.label, null);
      }
      this.label = "";
    }
  },
  computed: {
    labelIsValid() {
      return util.validateLabel(this.label);
    }
  }
};
</script>

<style scoped>
.error {
  color: red;
  text-decoration-line: underline;
  text-decoration-style: wavy;
}
.label-item {
  font-family: monospace;
}
.remove-icon {
  color: red;
}
.remove-icon:hover {
  color: blue;
  cursor: pointer;
}
.list--material {
  border-bottom: solid 1px lightgray;
}
.list-header--material {
  background: #efeff4;
  text-transform: uppercase;
  line-height: normal;
  border-bottom: solid 1px lightgray;
}
</style>



// WEBPACK FOOTER //
// src/pages/DelPage.vue